import { N_DASH } from '@monoimin/constants';

export function formatCount(
  count?: string | number | (string | number)[]
): string {
  if (!count) {
    return '';
  }

  if (typeof count === 'number' || typeof count === 'string') {
    return String(count);
  }

  const normalizedCount = count.map(Number).filter(Boolean);

  if (normalizedCount.length === 0) {
    return '';
  }

  if (normalizedCount.length === 1) {
    return String(normalizedCount[0]);
  }

  const sorted = normalizedCount.sort((a, b) => a - b);

  const first = sorted[0];

  const last = sorted[sorted.length - 1];

  if (first === last) {
    return String(first);
  }

  return `${first}${N_DASH}${last}`;
}

export default formatCount;
